import BaseResource from './index'
import validators from '../utilities/validation'

function validateName(value, instance, ValidationError) {
    try {
        validators.isNonEmpty(value, instance, ValidationError)
    } catch (validationError) {
        validationError.field = 'Name'
        throw validationError + '(' + validationError.field + ')'
    }
}

function validateNameReports(value, instance, ValidationError) {
    try {
        validators.isNonEmpty(value, instance, ValidationError)
    } catch (validationError) {
        validationError.field = 'Name Reports'
        throw validationError + '(' + validationError.field + ')'
    }
}

function validateNameLegal(value, instance, ValidationError) {
    try {
        validators.isNonEmpty(value, instance, ValidationError)
    } catch (validationError) {
        validationError.field = 'Name Legal'
        throw validationError + '(' + validationError.field + ')'
    }
}

function validateTin(value, instance, ValidationError) {
    try {
        validators.isNonEmpty(value, instance, ValidationError)
    } catch (validationError) {
        validationError.field = 'Tax ID'
        throw validationError + '(' + validationError.field + ')'
    }
}

function validateExtPayrollId(value, instance, ValidationError) {
    try {
        validators.isNonEmpty(value, instance, ValidationError)
    } catch (validationError) {
        validationError.field = 'Apex Client'
        throw validationError + '(' + validationError.field + ')'
    }
}

function validatePropayId(value, instance, ValidationError) {
    try {
        validators.isNumeric(value, instance, ValidationError)
    } catch (validationError) {
        validationError.field = 'ProPay ID'
        throw validationError + '(' + validationError.field + ')'
    }
}

function validateCompanyId(value, instance, ValidationError) {
    try {
        validators.isNonEmpty(value, instance, ValidationError)
    } catch (validationError) {
        validationError.field = 'Company Id'
        throw validationError + '(' + validationError.field + ')'
    }
}

function validateEntityTypeId(value, instance, ValidationError) {
    try {
        validators.isNonEmpty(value, instance, ValidationError)
    } catch (validationError) {
        validationError.field = 'Entity Type Id'
        throw validationError + '(' + validationError.field + ')'
    }
}

function validateOrgTypeId(value, instance, ValidationError) {
    try {
        validators.isNonEmpty(value, instance, ValidationError)
    } catch (validationError) {
        validationError.field = 'Org Type Id'
        throw validationError + '(' + validationError.field + ')'
    }
}

function validateIndustryTypeId(value, instance, ValidationError) {
    try {
        validators.isNonEmpty(value, instance, ValidationError)
    } catch (validationError) {
        validationError.field = 'Industry Type Id'
        throw validationError + '(' + validationError.field + ')'
    }
}

function validateStatus(value, instance, ValidationError) {
    try {
        validators.isZeroOrOne(value, instance, ValidationError)
    } catch (validationError) {
        validationError.field = 'Status'
        throw validationError + '(' + validationError.field + ')'
    }
}

function validateCertificationEnabled(value, instance, ValidationError) {
    try {
        validators.isZeroOrOne(value, instance, ValidationError)
    } catch (validationError) {
        validationError.field = 'Status'
        throw validationError + '(' + validationError.field + ')'
    }
}

function validateMainAddress1(value, instance, ValidationError) {
    try {
        validators.isNonEmpty(value, instance, ValidationError)
    } catch (validationError) {
        validationError.field = 'Main Address 1'
        throw validationError + '(' + validationError.field + ')'
    }
}

function validateMainCity(value, instance, ValidationError) {
    try {
        validators.isNonEmpty(value, instance, ValidationError)
    } catch (validationError) {
        validationError.field = 'Main City'
        throw validationError + '(' + validationError.field + ')'
    }
}

function validateMainStateId(value, instance, ValidationError) {
    try {
        validators.isNonEmpty(value, instance, ValidationError)
    } catch (validationError) {
        validationError.field = 'Main State Id'
        throw validationError + '(' + validationError.field + ')'
    }
}

function validateMainPostal(value, instance, ValidationError) {
    try {
        validators.isNonEmpty(value, instance, ValidationError)
    } catch (validationError) {
        validationError.field = 'Main Postal'
        throw validationError + '(' + validationError.field + ')'
    }
}

function validateMainCountryId(value, instance, ValidationError) {
    try {
        validators.isNonEmpty(value, instance, ValidationError)
    } catch (validationError) {
        validationError.field = 'Main Country Id'
        throw validationError + '(' + validationError.field + ')'
    }
}

function validatePayFrequencyId(value, instance, ValidationError) {
    try {
        validators.isNonEmpty(value, instance, ValidationError)
    } catch (validationError) {
        validationError.field = 'Main Pay Frequency Id'
        throw validationError + '(' + validationError.field + ')'
    }
}

function validateWeekEndingId(value, instance, ValidationError) {
    try {
        validators.isNonEmpty(value, instance, ValidationError)
    } catch (validationError) {
        validationError.field = 'Main Week Ending Id'
        throw validationError + '(' + validationError.field + ')'
    }
}

function validatePayDateBasis(value, instance, ValidationError) {
    try {
        validators.isDateYMDFormat(value, instance, ValidationError)
    } catch (validationError) {
        validationError.field = 'Pay Date Basis'
        throw validationError + '(' + validationError.field + ')'
    }
}

function validatePrepStart(value, instance, ValidationError) {
    try {
        validators.isDateYMDFormat(value, instance, ValidationError)
    } catch (validationError) {
        validationError.field = 'Prep Start Date'
        throw validationError + '(' + validationError.field + ')'
    }

    if (instance.attributes.prep_start_date && !instance.attributes.prep_end_date) {
        throw 'validationError : Please enter prep_end_date'
    }
}

function validatePrepEnd(value, instance, ValidationError) {
    try {
        validators.isDateYMDFormat(value, instance, ValidationError)
    } catch (validationError) {
        validationError.field = 'Prep End Date'
        throw validationError + '(' + validationError.field + ')'
    }

    if (!instance.attributes.prep_start_date && instance.attributes.prep_end_date) {
        throw 'validationError : Please enter prep_start_date'
    }

    if (instance.attributes.prep_start_date && instance.attributes.prep_end_date) {
        if (new Date(instance.attributes.prep_start_date) > new Date(instance.attributes.prep_end_date)) {
            throw 'validationError : Please check prep_start_date and prep_end_date'
        }
    }
}

function validateWrapStart(value, instance, ValidationError) {
    try {
        validators.isDateYMDFormat(value, instance, ValidationError)
    } catch (validationError) {
        validationError.field = 'Post Start Date'
        throw validationError + '(' + validationError.field + ')'
    }

    if (instance.attributes.post_start_date && !instance.attributes.post_end_date) {
        throw 'validationError : Please enter post_end_date'
    }
}

function validateWrapEnd(value, instance, ValidationError) {
    try {
        validators.isDateYMDFormat(value, instance, ValidationError)
    } catch (validationError) {
        validationError.field = 'Post End Date'
        throw validationError + '(' + validationError.field + ')'
    }

    if (!instance.attributes.post_start_date && instance.attributes.post_end_date) {
        throw 'validationError : Please enter post_start_date'
    }

    if (instance.attributes.post_start_date && instance.attributes.post_end_date) {
        if (new Date(instance.attributes.post_start_date) > new Date(instance.attributes.post_end_date)) {
            throw 'validationError : Please check post_start_date and post_end_date'
        }
    }
}

function validateOtherProperties(value, instance, ValidationError) {
    let json
    if (typeof value === 'string') {
        try {
            json = JSON.parse(value)
        } catch (validationError) {
            validationError.field = 'Other Properties'
            throw validationError
        }
    } else if (typeof value === 'object') {
        json = value
    } else {
        json = {}
    }

    if (json) instance.attributes.other_properties = json

    try {
        validators.isNonEmpty(value, instance, ValidationError)
    } catch (validationError) {
        validationError.field = 'Other Properties'
        throw validationError + '(' + validationError.field + ')'
    }
}

export default class EntitiesResource extends BaseResource {
    static endpoint = '/oasis/restv3/admin/entities'
    static related() {
        return {
            parent_id: this,
        }
    }

    static validation = {
        name: validateName,
        name_legal: validateNameLegal,
        name_reports: validateNameReports,
        tin: validateTin,
        company_id: validateCompanyId,
        entity_type_id: validateEntityTypeId,
        org_type_id: validateOrgTypeId,
        industry_type_id: validateIndustryTypeId,
        status: validateStatus,
        certification_enabled: validateCertificationEnabled,
        main_address1: validateMainAddress1,
        main_city: validateMainCity,
        main_state_id: validateMainStateId,
        main_postal: validateMainPostal,
        main_country_id: validateMainCountryId,
        pay_frequency_id: validatePayFrequencyId,
        week_ending_id: validateWeekEndingId,
        other_properties: validateOtherProperties,
        pay_date_basis: validatePayDateBasis,
        prep_start_date: validatePrepStart,
        prep_end_date: validatePrepEnd,
        post_start_date: validateWrapStart,
        post_end_date: validateWrapEnd,
    }
}
